"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Option = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _classnames2 = _interopRequireDefault(require("../../../utils/classnames"));
require("./DropUpMenu.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DropUpMenu = function DropUpMenu(_ref) {
  var id = _ref.id,
    orientation = _ref.orientation,
    icon = _ref.icon,
    iconData = _ref.iconData,
    text = _ref.text,
    children = _ref.children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var handleClick = function handleClick(e) {
    e.preventDefault();
  };
  var close = function close(e) {
    if (e.button === 2) return;
    e.preventDefault();
    setOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    id: id,
    className: "uin-ddms-button ".concat(isOpen ? 'open' : ''),
    onMouseDown: handleClick
  }, icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(icon),
    "data-color": iconData,
    style: {
      '--data-color': iconData
    }
  }), text && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-ddms-text"
  }, text), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon tiny ".concat(isOpen ? 'arrow-action-up' : 'arrow-action')
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
    target: id,
    toggle: function toggle() {
      return setOpen(function (o) {
        return !o;
      });
    },
    isOpen: isOpen,
    placement: "top-start",
    hideArrow: true,
    trigger: "legacy",
    popperClassName: "uin-ddms-options-wrapper",
    boundariesElement: "window",
    onMouseDown: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, {
    className: "uin-ddms-options ".concat(orientation),
    onMouseDown: close
  }, children)));
};
var Option = exports.Option = function Option(_ref2) {
  var _classnames;
  var children = _ref2.children,
    selected = _ref2.selected,
    icon = _ref2.icon,
    className = _ref2.className,
    style = _ref2.style,
    onClick = _ref2.onClick;
  var classes = (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, className, className != null), _defineProperty(_classnames, "selected", selected), _classnames));
  var handleClick = function handleClick(e) {
    if (e.button === 2) return false;
    e.preventDefault();
    onClick();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ddms-option ".concat(classes),
    style: style,
    onMouseDown: handleClick
  }, selected && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon sent"
  }), children && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ddms-text-option"
  }, children), icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(icon)
  }));
};
DropUpMenu.propTypes = {
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical', 'palette']),
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  icon: _propTypes["default"].string,
  text: _propTypes["default"].string
};
var _default = exports["default"] = DropUpMenu;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/DropUpMenu/DropUpMenu.js
// module id = 1433
// module chunks = 0